import decodeJwt from "@/helpers/decodeJwt"
import getUserType from "@/helpers/getUserType"
import { useMainStore } from "@/stores/MainStore"

export default () => {
  const { apiVersion } = useMainStore()
  if (getUserType()) {
    return `${ apiVersion }/${ getUserType() }`
  }
}
